import { useReactlytics } from '@americanexpress/reactlytics';
import { useCallback } from 'react';

const useClickTracking = () => {
  const { track } = useReactlytics();
  return useCallback((option) => track({
    event: {
      ...option,
      type: 'click',
    },
  }), [track]);
};

export default useClickTracking;
